import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import {
  AppDialog,
  AppDialogActions,
  AppDialogCancelButton,
  AppDialogContent,
  AppDialogPrimaryButton,
  AppDialogTitle,
} from "../../../components/dialog";
import { AppTextField } from "../../../components/form";

export type FormFillRow = {
  formKey: string;
  formLabel: string;
  fieldKey: string;
  meaning: string;
  value: string;
};

type Props = {
  open: boolean;
  busy: boolean;
  error: string | null;
  notice: string | null;
  rows: FormFillRow[];
  onChange: (index: number, value: string) => void;
  onClose: () => void;
  onConfirm: () => void;
};

export default function FormFillDialog({
  open,
  busy,
  error,
  notice,
  rows,
  onChange,
  onClose,
  onConfirm,
}: Props) {
  const { t } = useTranslation();
  const canConfirm = !busy && rows.length > 0 && !notice;
  return (
    <AppDialog open={open} onClose={() => !busy && onClose()} maxWidth="sm" fullWidth>
      <AppDialogTitle>{t("chat.formFill.title")}</AppDialogTitle>
      <AppDialogContent>
        {busy && (
          <Typography variant="body2" color="text.secondary">
            {t("chat.formFill.busy")}
          </Typography>
        )}
        {error && (
          <Typography variant="body2" color="error" sx={{ mb: rows.length ? 1.5 : 0 }}>
            {error}
          </Typography>
        )}
        {notice && <Typography variant="body2">{notice}</Typography>}
        <Stack spacing={1.5} sx={{ mt: rows.length ? 0.5 : 0 }}>
          {rows.map((row, index) => (
            <AppTextField
              key={`${row.formKey}:${row.fieldKey}`}
              label={`${row.formLabel} · ${row.meaning}`}
              value={row.value}
              size="small"
              disabled={busy}
              onChange={(event) => onChange(index, event.target.value)}
            />
          ))}
        </Stack>
      </AppDialogContent>
      <AppDialogActions>
        <AppDialogCancelButton onClick={onClose} disabled={busy}>
          {t("common.close")}
        </AppDialogCancelButton>
        {canConfirm && (
          <AppDialogPrimaryButton onClick={onConfirm}>{t("chat.formFill.confirm")}</AppDialogPrimaryButton>
        )}
      </AppDialogActions>
    </AppDialog>
  );
}
